import './public-path';
import './swiper-styles';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import './css/common.scss';
import './css/bulma-tune.scss';
import './SearchShell.scss';

import { rootlink } from './config';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from "react-router-dom";

const App = React.lazy(() => import('./App'));

function AppFallback() {
	return (
		<div className="suspense-fallback" aria-busy="true">
			<div className="search-shell__cards">
				<div className="search-shell__card" />
				<div className="search-shell__card" />
			</div>
		</div>
	);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<BrowserRouter>
		<Suspense fallback={<AppFallback />}>
			<Routes>
				<Route path={rootlink} element={<App />} />
				<Route path={rootlink + 'private/'} element={<App />} />
				<Route path={rootlink + 'hos/'} element={<App />} />
				<Route path={rootlink + 'white/'} element={<App />} />
				<Route path={rootlink + 'bldg/'} element={<App />} />
				<Route path={rootlink + 'tran/'} element={<App />} />
				<Route path={rootlink + 'branch/'} element={<App />} />
				<Route path={rootlink + 'shop/'} element={<App />} />
				<Route path={rootlink + 'private/fav/'} element={<App />} />
				<Route path={rootlink + 'hos/fav/'} element={<App />} />
				<Route path={rootlink + 'white/fav/'} element={<App />} />
				<Route path={rootlink + 'bldg/fav/'} element={<App />} />
				<Route path={rootlink + 'branch/fav/'} element={<App />} />
				<Route path={rootlink + 'shop/fav/'} element={<App />} />
			</Routes>
		</Suspense>
	</BrowserRouter>
);

reportWebVitals();
